module.exports = __webpack_public_path__ + "img/img5.af1857aa.png";